export default {
  header: {
    review_us: 'Recensici su Google',
    upload: 'Carica recensione Google',
    not_now: 'Non ora',
  },
  steps: {
    how_it_works: 'Come funziona',
    step_1: {
      title: 'Passo',
      description: 'Scrivi una recensione di {{name}} su Google',
    },
    step_2: {
      title: 'Passo',
      description: 'Carica uno screenshot della recensione pubblicata (vedi esempio sotto)',
    },
  },
  buttons: {
    upload_screenshot: 'Carica Screenshot',
    leave_google_review: 'Lascia una recensione su Google',
    submit_screenshot: 'Invia Screenshot',
    return: 'Indietro',
  },
  enter_name: {
    title: 'Nome pubblicato con la tua recensione Google',
    place_holder: 'Inserisci nome',
  },
  screenshot_uploaded: {
    title: 'Screenshot caricato',
    description: 'Scorri verso il basso per vedere lo screenshot completo',
  },
  loading: {
    processing: 'La tua recensione pubblicata è in fase di revisione',
  },
  error_messages: {
    upload_failed: 'Caricamento screenshot fallito. Riprova.',
    review_already_uploaded:
      'Sembra che tu abbia già caricato uno screenshot di una recensione Google. Puoi ricevere il premio al massimo una volta per una recensione Google 😊',
    name_missing: {
      description:
        'Inserisci il nome pubblicato con la tua recensione Google per aiutarci ad abbinare le informazioni.',
      button: {
        title: 'Ok',
      },
    },
  },
};
